import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { CargoSpacesSummaryService } from 'src/app/core/services/cargo-spaces-summary.service';
import { ProjectService } from 'src/app/core/services/project.service';
import { shouldShowLdmInProjectSummary } from 'src/app/shared/helpers/pallet-loading-space.helper';
import { displayedLoadingSpaceCount } from 'src/app/shared/helpers/pallet-workspace-collapse.helper';
import { Project } from 'src/app/core/objects/project';

@Component({
    selector: 'gl-loading-spaces-summary',
    templateUrl: './loading-spaces-summary.component.html',
    styleUrls: ['./loading-spaces-summary.component.scss'],
    standalone: false
})
export class LoadingSpacesSummaryComponent implements OnDestroy {
  public unit: string;
  public workSpacesSummary;
  public workSpacesLength: number;
  public isMobile: boolean;
  private project: Project;
  private readonly subscriptions = new Subscription();
  @Input() isClosed = false

  constructor(
    private cargoSpacesSummaryService: CargoSpacesSummaryService,
    private projectService: ProjectService,
    private router: Router,
    private translate: TranslateService,
  ) {
    this.isMobile = this.router.url.includes('mobile');
    this.subscriptions.add(
      this.projectService.project.subscribe((project) => {
        this.project = project;
        this.unit = project?.options?.unit;
        this.workSpacesLength = displayedLoadingSpaceCount(project?.workSpaces);
        this.workSpacesSummary = this.cargoSpacesSummaryService.workSpacesSummary;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public totalLDMTooltip() {
    const total = _.round(this.workSpacesSummary?.takenLdm + this.workSpacesSummary?.freeLdm, 2);
    const percentOccupied = _.round((this.workSpacesSummary?.takenLdm / total) * 100);
    return (
      this.translate.instant('occupied') +
      ': ' +
      this.workSpacesSummary?.takenLdm +
      ` (${percentOccupied}%) ` +
      ' / ' +
      this.translate.instant('total') +
      ': ' +
      total +
      ' LDM'
    );
  }

  public calculateLineWidthPercentage(plus?: number) {
    if (this.workSpacesSummary) {
      const percentage =
        (this.workSpacesSummary.takenLdm /
          (this.workSpacesSummary.freeLdm + this.workSpacesSummary.takenLdm)) *
        100;
      if (percentage === 0) {
        return 0;
      } else if (plus) {
        return percentage + plus;
      } else {
        return percentage;
      }
    } else {
      return 0;
    }
  }

  public isTotalWeightOverLimit() {
    return this.workSpacesSummary?.limit < this.workSpacesSummary?.totalWeight;
  }

  public getAreaAndVolumeUnit() {
    return this.unit === 'cm' || this.unit === 'mm' ? 'm' : 'in';
  }

  public showLdm(): boolean {
    return shouldShowLdmInProjectSummary(this.project);
  }
}
